module.exports = {
  user: ( User ) ->
    User.resolve()

  chartjs: ( user, $ocLazyLoad, Utils ) ->
    if !user.is_staff
      return

    # To be compatible with Angular 1.2, angular-chart.js needs:
    # - An angular.merge() polyfill
    # - jQuery (for angular.element.cleanData()), which we already have
    # See https://github.com/jtblin/angular-chart.js/issues/570 for more
    if !angular.merge
      angular.merge = Utils.merge

    return $ocLazyLoad.load( '/static/dist/Chart.min.js' ).then () ->
      $ocLazyLoad.load
        name: 'chart.js'
        files: [ '/static/dist/angular-chart.min.js' ]

  stickyMessage: (Api) ->
    return Api.StickyMessage.get().$promise

}
